export default {
  placeholder: 'Vybrať stav',
};
